import { render, staticRenderFns } from "./catRolesEdit.vue?vue&type=template&id=db68d1f4&"
import script from "./catRolesEdit.vue?vue&type=script&lang=js&"
export * from "./catRolesEdit.vue?vue&type=script&lang=js&"
import style0 from "./catRolesEdit.vue?vue&type=style&index=0&id=db68d1f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports